/**
 * Axios base configuration.
 * All API modules import `API` from here — change the base URL in one place.
 *
 * `withCredentials: true` is set globally so that the HttpOnly auth cookie
 * (`dd_access_token`) is sent on every cross-origin request.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Send cookies on every request to the backend (auth lives in an HttpOnly cookie).
axios.defaults.withCredentials = true;
